<div class="container-fluid p-0">

  <ng-container *ngIf="canCreateHazards && !canViewHazards">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <span class="mr-auto">
        <mat-menu #linkMenuNoView="matMenu">
          <button mat-menu-item (click)="onAdd()">
            New Hazard
          </button>
          <button mat-menu-item (click)="onSelectHazards()" *ngIf="canViewHazards">
            Link Hazards
          </button>
          <ng-container *ngIf="canViewHazardTemplates">
            <button mat-menu-item (click)="onCopy()">
              Select Templates
            </button>
          </ng-container>
        </mat-menu>

        <button
          mat-raised-button
          color="primary"
          class="m-1 mr-2"
          matTooltip="Add a new or existing Incident Hazard & Risk."
          [matMenuTriggerFor]="linkMenuNoView"
          id="menu-button-no-view">
          <mat-icon>add</mat-icon>
          Add Hazard
        </button>
      </span>
    </nav>
  </ng-container>

  <div class="alert alert-warning m-3" *ngIf="!canViewHazards">
    You do not have permission to view hazards/risks.
    <span *ngIf="canCreateHazards">You can still create new hazards/risks using the button above.</span>
    <span *ngIf="!canCreateHazards">Please contact your administrator to request access.</span>
  </div>

  <ng-container *ngIf="canViewHazards">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <span class="mr-auto">
        <ng-container *ngIf="canCreateHazards">
          <mat-menu #linkMenu="matMenu">
            <button mat-menu-item (click)="onAdd()">
              New Hazard
            </button>
            <button mat-menu-item (click)="onSelectHazards()">
              Link Hazards
            </button>
            <ng-container *ngIf="canViewHazardTemplates">
              <button mat-menu-item (click)="onCopy()">
                Select Templates
              </button>
            </ng-container>
          </mat-menu>

          <button
            mat-raised-button
            color="primary"
            class="m-1 mr-2"
            matTooltip="Add a new or existing Incident Hazard & Risk."
            [matMenuTriggerFor]="linkMenu"
            id="menu-button">
            <mat-icon>add</mat-icon>
            Add Hazard
          </button>
        </ng-container>

        <ng-container *ngIf="canDeleteHazards">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item (click)="onUnlinkSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>delete</mat-icon> Unlink Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Incident Hazards & Risks." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search" />
        <button
          mat-raised-button
          class="mx-0 my-1"
          color="secondary"
          type="submit">
          <mat-icon>search</mat-icon>Search
        </button>
      </form>
    </nav>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef id="th-select">
          <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
                        [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
                        [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? dataSource.selection.toggle(row.id) : null"
                        [checked]="dataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef id="th-id">
          #
        </th>
        <td mat-cell *matCellDef="let hazard">
          {{ hazard.id }}
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef id="th-name">Hazard/Risk</th>
        <td mat-cell *matCellDef="let hazard" class="text-wrap">
          <b>{{ hazard.name }}</b> <br />
          <small>{{ hazard.description }}</small>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell mat-sort-header *matHeaderCellDef id="th-status">Status</th>
        <td mat-cell *matCellDef="let hazard">{{ hazard.status }}</td>
      </ng-container>

      <!-- Initial Risk Assessment Column -->
      <!-- Initial Risk Assessment Score Column -->
      <ng-container matColumnDef="ira_score">
        <th mat-header-cell *matHeaderCellDef id="th-ira-score">
          <span matTooltip="Initial Risk Assessment Score">IRA Score</span>
        </th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(hazard.ira_score_band ?? utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
            {{ hazard.ira_score ?? utils.calculateRiskScore(hazard.ira_likelihood, hazard.ira_severity) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ira">
        <th mat-header-cell *matHeaderCellDef id="th-ira">
          <span matTooltip="Initial Risk Assessment">IRA</span>
        </th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity))">
            {{ utils.getRiskAssessmentText(hazard.ira_likelihood, hazard.ira_severity) }}
          </span>
        </td>
      </ng-container>

      <!-- Residual Risk Assessment Score Column -->
      <ng-container matColumnDef="rra_score">
        <th mat-header-cell *matHeaderCellDef id="th-rra-score">
          <span matTooltip="Residual Risk Assessment Score">RRA Score</span>
        </th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(hazard.rra_score_band ?? utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
            {{ hazard.rra_score ?? utils.calculateRiskScore(hazard.rra_likelihood, hazard.rra_severity) }}
          </span>
        </td>
      </ng-container>

      <!-- Residual Risk Assessment Column -->
      <ng-container matColumnDef="rra">
        <th mat-header-cell *matHeaderCellDef id="th-rra">
          <span matTooltip="Residual Risk Assessment">RRA</span>
        </th>
        <td mat-cell *matCellDef="let hazard">
          <span [class]="utils.getSiteRiskStatusTextColor(utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity))">
            {{ utils.getRiskAssessmentText(hazard.rra_likelihood, hazard.rra_severity) }}
          </span>
        </td>
      </ng-container>

      <!-- Controls Column -->
      <ng-container matColumnDef="controls">
        <th mat-header-cell *matHeaderCellDef id="th-controls">Controls</th>
        <td mat-cell *matCellDef="let hazard">
          {{ getHazardControlsCount(hazard.controls) }}
        </td>
      </ng-container>

      <!-- Date Created Column -->
      <ng-container matColumnDef="date_created">
        <th mat-header-cell mat-sort-header *matHeaderCellDef id="th-date_created" matTooltip="Toggle sorting by the date the Hazard/Risk was created.">Created At</th>
        <td mat-cell *matCellDef="let hazard">
          {{ (hazard.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <!-- Date Created (UTC) Column -->
      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell mat-sort-header *matHeaderCellDef id="th-date_created_UTC" matTooltip="Toggle sorting by the date the Hazard/Risk was created.">Created At (UTC)</th>
        <td mat-cell *matCellDef="let hazard">
          {{ (hazard.date_created * 1000) | timezoneConvertUTCMedium }}
        </td>
      </ng-container>

      <!-- Reviewer Date Column -->
      <ng-container matColumnDef="reviewer_date">
        <th mat-header-cell *matHeaderCellDef>Review At</th>
        <td mat-cell *matCellDef="let hazard">
          {{ hazard.reviewer_date ? ((hazard.reviewer_date * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef id="th-actions" [style.width.px]="240"></th>

        <td mat-cell *matCellDef="let hazard">
          <button type="button" mat-button (click)="onView(hazard)">
            View
          </button>

          <button type="button" mat-button (click)="onEdit(hazard)" *ngIf="canEditHazards">
            Edit
          </button>

          <button type="button" mat-button (click)="onUnlink(hazard.id)" *ngIf="canDeleteHazards">
            Unlink
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </ng-container>

</div>
